import React from "react";

function PreviewExperienceList({ listItem }) {
  return (
    <>
      <li>{listItem.item}</li>
    </>
  );
}

export default PreviewExperienceList;
